class CartLink extends HTMLElement {
  constructor() {
    super();

    this.itemsCount = this.querySelector('items-count');
  }

  connectedCallback() {
    this.unsubscribe = window.theme.cart.store.subscribe((state) => {
      /* ITG TS - old code start */
      // this.itemsCount.innerHTML = state.products.item_count.toString();
      /* ITG TS - old code end */
      /* ITG TS - display count: fabric items qty / 10 */
      this.itemsCount.innerHTML = this._getDisplayCount(state.products);
    });
  }

  disconnectedCallback() {
    this.unsubscribe();
  }

  /* ITG TS - display count: fabric items qty / 10 */
  _getDisplayCount(products) {
    if (!products || !products.items || !products.items.length) return '0';
    let hasFabric = false;
    const total = products.items.reduce((sum, item) => {
      const isFabric = item.properties && item.properties._fabric_moq === 'true';
      if (isFabric) {
        hasFabric = true;
        return sum + (item.quantity / 10);
      }
      return sum + item.quantity;
    }, 0);
    return hasFabric ? parseFloat(total.toFixed(1)).toString() : total.toString();
  }
}
customElements.define('cart-link', CartLink);

/*class CartLink extends HTMLElement {
  constructor() {
    super();

    this.itemsCount = this.querySelector('items-count');
  }

  connectedCallback() {
    this.unsubscribe = window.theme.cart.store.subscribe((state) => {
      this.itemsCount.innerHTML = state.products.item_count.toString();
    });
  }

  disconnectedCallback() {
    this.unsubscribe();
  }
}
customElements.define('cart-link', CartLink);*/
